import React from 'react';
import WithIconTimeLineItem from 'components/timeline/OrderTimeline';
import { NewReleases, CreditCard } from '@mui/icons-material';
import { buyerOrderLogs } from 'util/holdForBuyer';

// The BUYER's copy of the order timeline (the seller's lives in components/trackOrder). Its entries
// go through buyerOrderLogs, which drops the hold-for-buyer release entry and rewrites the hold one
// into "Processed / Order has been processed" - after which the status-driven colour and icon below
// pick it up as an ordinary Processed step with no further help.
const TrackOrder = (props) => {
  const { orderDetails } = props;
  const timeline = buyerOrderLogs(orderDetails);

  return (
    <React.Fragment>
      <div className="timeline-section timeline-center clearfix animated slideInUpTiny animation-duration-3" >
        {
          orderDetails && Object.keys(orderDetails).length > 0 && timeline.length > 0 ?
            timeline.map((value, key) => {
              return <WithIconTimeLineItem styleName={(key === 0 || key === 2 || key === 4 || key === 6 || key === 8 || key === 10) ? 'timeline-inverted' : ''} timeLine={value} color={value.status === 'Processed' ? 'blue' : value.status === 'New' ? 'red' : value.status === 'Cancelled' ? 'grey' : value.status === 'Ready For Dispatch' ? 'orange' : value.status === 'Delivered' ? 'green' : 'info'}>
                {
                  value.status === 'Processed' ? <CreditCard /> : value.status === 'New' ? <NewReleases /> : value.status === 'Cancelled' ? <div><i style={{ fontSize: '1.5rem', paddingTop: 14 }} class="zmdi zmdi-close"></i></div> : value.status === 'Ready For Dispatch' ? <div><i style={{ fontSize: '1.5rem', paddingTop: 14 }} class="zmdi zmdi-run"></i></div> : value.status === 'Delivered' ? <div><i style={{ fontSize: '1.5rem', paddingTop: 14 }} class="zmdi zmdi-check"></i></div> : <div><i style={{ fontSize: '1.5rem', paddingTop: 14 }} class="zmdi zmdi-truck"></i></div>
                }
              </WithIconTimeLineItem>
            }) : ''
        }
      </div>
    </React.Fragment>
  );
}

export default TrackOrder;
